import { PayloadAction } from "@reduxjs/toolkit";
import { GroupsState } from "../../models/GroupsState";
import { SearchClientsPayload } from "../../payload/SearchClients/SearchClientsPayload";

const searchClientsFetch = (state: GroupsState, action: PayloadAction<SearchClientsPayload>) => {
    state.isLoading = true;
}

export default searchClientsFetch;